
import axios from 'axios'

export default {
    getFoodCategoryList({commit}, params){
        return axios.post('/api/background/food_category/list', params)
    },
    addFoodCategory({commit}, params){
        return axios.post('/api/background/food_category/add', params)
    },
    modifyFoodCategory({commit}, params){
        return axios.post('/api/background/food_category/modify', params)
    },
    deleteFoodCategory({commit}, params){
        return axios.post('/api/background/food_category/delete', params)
    },
    getFoodList({commit}, params){
        return axios.post('/api/background/canteen_food/new/list', params)
    },
    mulAddFood({commit}, params){
        return axios.post('/api/background/canteen_food/batch/add', params)
    },
    addFood({commit}, params){
        return axios.post('/api/background/canteen_food/add', params)
    },
    modifyFood({commit}, params){
        return axios.post('/api/background/canteen_food/modify', params)
    },
    deleteFood({commit}, params){
        return axios.post('/api/background/canteen_food/batch/delete', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/food.js